import React, { useState, useEffect } from "react";
import "./EditUserForm.css"; 

const EditProductForm = ({ inventory, onClose, onSave }) => {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  const token = localStorage.getItem("token");
  const [partners, setPartners] = useState([]);
  const [formData, setFormData] = useState({
    asset1_name: inventory.asset1_name || "",
    asset2_name: inventory.asset2_name || "",
    imei_number: inventory.imei_number || "",
    serial_number: inventory.serial_number || "",
    inventory_type: inventory.inventory_type || "",
    item_condition: inventory.item_condition || "working",
    location_name: inventory.location_name || "",
    delivery_order_number: inventory.delivery_order_number || "",
    partner_id: inventory.partner_id || ""
  });

  // Fetch partners on mount
  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const res = await fetch("/api/partners", {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        if (!res.ok) throw new Error(`Failed to fetch partners (${res.status})`);
        const data = await res.json();

        // /api/partners returns a bare array with partner_id AS id, partner_name AS name
        // already aliased server-side (server.js:1247) — no pagination wrapper here.
        setPartners(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("❌ Error fetching partners:", err);
      }
    };
    fetchPartners();
  }, [token]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`/api/products/update/${inventory.inventory_id}`, {
       method: "PUT",
       headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${token}`
       },
       body: JSON.stringify(formData),
     });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Failed to update inventory (${response.status})`);
      }

      const data = await response.json();
      console.log("✅ Update success:", data);

      onSave({ ...inventory, ...formData });
      onClose();

    } catch (error) {
      console.error("❌ Error updating inventory:", error);
      alert("Failed to update inventory. Please try again.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content1">
        <button className="close-button" onClick={onClose}>✖</button>
        <h3>Edit</h3>

        <form onSubmit={handleSubmit}>

          <div className="form-group">
            <label id="add-user-label">Name:</label>
            <input id='edit-user-firstname' type="text" name="asset1_name" value={formData.asset1_name} onChange={handleChange} required
              disabled={!permissions.includes("inventory_edit_name")}
              style={{
                backgroundColor: !permissions.includes("inventory_edit_name") ? "#f0f0f0" : "white",
                cursor: !permissions.includes("inventory_edit_name") ? "not-allowed" : "text" 
              }} 
            />            
          </div>

          <div className="form-group">
            <label id="add-user-label">Color:</label>
            <input id='edit-user-firstname' type="text" name="asset2_name" value={formData.asset2_name} onChange={handleChange} required 
              disabled={!permissions.includes("inventory_edit_color")}
              style={{
                backgroundColor: !permissions.includes("inventory_edit_color") ? "#f0f0f0" : "white",
                cursor: !permissions.includes("inventory_edit_color") ? "not-allowed" : "text" 
              }} 
            />
          </div>

          <div className="form-group">
            <label id="add-user-label">Imei Number:</label>
            <input id='edit-user-firstname' type="text" name="imei_number" value={formData.imei_number} onChange={handleChange} 
              disabled={!permissions.includes("inventory_edit_imei_number")}
              style={{
                backgroundColor: !permissions.includes("inventory_edit_imei_number") ? "#f0f0f0" : "white",
                cursor: !permissions.includes("inventory_edit_imei_number") ? "not-allowed" : "text" 
              }} 
            />
          </div>

          <div className="form-group">
            <label id="add-user-label">Serial Number:</label>
            <input id='edit-user-firstname' type="text" name="serial_number" value={formData.serial_number} onChange={handleChange} 
              disabled={!permissions.includes("inventory_edit_serialnumber")}
              style={{
                backgroundColor: !permissions.includes("inventory_edit_serialnumber") ? "#f0f0f0" : "white",
                cursor: !permissions.includes("inventory_edit_serialnumber") ? "not-allowed" : "text" 
              }} 
            />
          </div>

          <div className="form-group">
            <label id="add-user-label">Type:</label>
            <select
              id='edit-user-firstname' 
              name="inventory_type"
              value={formData.inventory_type}
              onChange={handleChange}
              required
              disabled={!permissions.includes("inventory_edit_inventory_type")}
              style={{
                backgroundColor: !permissions.includes("inventory_edit_inventory_type") ? "#f0f0f0" : "white",
                cursor: !permissions.includes("inventory_edit_inventory_type") ? "not-allowed" : "text" 
              }} 
            >
              <option value="">Select Type</option>
              <option value="PO">PO</option>
              <option value="FOC">FOC</option>          
              <option value="HQ">HQ</option>  
            </select>
          </div>

          <div className="form-group">
  <label id="add-user-label">Condition:</label>
  <select
    id='edit-user-firstname'
    name="item_condition"
    value={formData.item_condition}
    onChange={handleChange}
    required
  >
    <option value="working">Working</option>
    <option value="faulty">Faulty</option>
  </select>
</div>

          <div className="form-group">
            <label id="add-user-label">Location:</label>
            <input id='edit-user-firstname' type="text" name="location_name" value={formData.location_name} onChange={handleChange} 
              disabled={!permissions.includes("inventory_edit_location_name")}
              style={{
                backgroundColor: !permissions.includes("inventory_edit_location_name") ? "#f0f0f0" : "white",
                cursor: !permissions.includes("inventory_edit_location_name") ? "not-allowed" : "text" 
              }} 
            />
          </div>

          <div className="form-group">
            <label id="add-user-label">DO Number:</label>
            <input id='edit-user-firstname' type="text" name="delivery_order_number" value={formData.delivery_order_number} onChange={handleChange} 
              disabled={!permissions.includes("inventory_edit_delivery_order_number")}
              style={{
                backgroundColor: !permissions.includes("inventory_edit_delivery_order_number") ? "#f0f0f0" : "white",
                cursor: !permissions.includes("inventory_edit_delivery_order_number") ? "not-allowed" : "text" 
              }} 
            />
          </div>

          {/* Partner Dropdown */}
          <div className="form-group">
            <label id="add-user-label">Partner:</label>
            <select
              id='edit-user-firstname'
              name="partner_id"
              value={formData.partner_id}
              onChange={handleChange}
            >
              <option value="">Select Partner</option>
              {partners.map((partner) => (
                <option key={partner.id} value={partner.id}>
                  {partner.name}
                </option>
              ))}
            </select>
          </div>

          <button type="submit" className="save-button">Save Changes</button>
        </form>
      </div>
    </div>
  );
};

export default EditProductForm;